export const meetingSidebarAriaLabel = "Meeting Sidebar";
